import type { IconData } from '@stacksjs/iconify-core'

export const bagFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M14.125 1.25C16.105.936 19.475.547 24 .547s7.894.39 9.874.703c1.916.304 3.176 1.97 3.176 3.792a8.96 8.96 0 0 1-3.08 6.771c2.257 1.355 4.285 3.104 6.008 5.07c3.988 4.55 6.523 10.455 6.523 15.809c0 5.515-2.694 9.33-6.923 11.678c-4.123 2.29-9.67 3.179-15.577 3.179s-11.454-.89-15.577-3.179C4.194 42.022 1.5 38.207 1.5 32.692c0-5.354 2.535-11.258 6.523-15.808c1.723-1.967 3.75-3.716 6.008-5.07a8.96 8.96 0 0 1-3.082-6.772c0-1.823 1.26-3.488 3.176-3.792\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M12.05 11.62a1.5 1.5 0 0 1 1.83-1.07c6.185 1.62 14.056 1.62 20.24 0a1.5 1.5 0 1 1 .76 2.901c-6.683 1.75-15.077 1.75-21.76 0a1.5 1.5 0 0 1-1.07-1.83Z\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bagFlat
